var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:{ disabled: _vm.disabled },attrs:{"type":_vm.type,"color":_vm.color,"disabled":_vm.disabled || _vm.loading},on:{"click":ev => !_vm.disabled && _vm.$emit('click', ev)}},[(!_vm.loading)?[_vm._v(_vm._s(_vm.text))]:_c('img',{attrs:{"src":"/imgs/loading-small.gif"}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }